module.exports = __webpack_public_path__ + "static/media/chrpe_inclass.38cad316.jpg";